import { string, object, ObjectSchema } from "yup";
import type { Airport, City, FlightFormLocation } from "@/app/lib/types/types";

export const getCityName = (location: FlightFormLocation | null) => {
  if (!location) {
    return "";
  }

  return location.type === "AIRPORT" ? location.cityName : location.name;
};

export const airportSchema: ObjectSchema<Airport> = object({
  id: string().required(),
  name: string().required(),
  code: string().required(),
  cityName: string().required(),
  countryName: string().required(),
  type: string().oneOf(["AIRPORT"]).required(),
});

export const citySchema: ObjectSchema<City> = object({
  id: string().required(),
  name: string().required(),
  code: string().optional(),
  countryName: string().required(),
  countryCode: string().optional(),
  type: string().oneOf(["CITY"]).required(),
});
